import timezones from "./timezones"
import { random, shuffle } from "lodash-es"
import { writable } from 'svelte-local-storage-store'

export const users = writable('users', [])

const randomSlice = (array, n) =>
	shuffle(array).slice(0, n)

const ogNames = [
	"Pete", "Lisa", "Marcia", "Marco",
	"Tara", "Sarah", "Nico", "Niki",
	"Evert", "Ale", "Maarten", "Anne",
	"Rose", "Marianne", "Tom", "Mike",
	"Bart", "Patxi", "Andre", "Falco"
]

let names = [ ...ogNames ]

export const reset = () => names = [ ...ogNames ]

export const makeUser = () => {
	const dayParts = ["morning", "afternoon", "evening"]
	const name = names.splice(random(0, names.length-1), 1)[0]

	return {
		name, email: name.toLowerCase()+"@gmail.com",
		tz: randomSlice([ ...timezones ], 1)[0].value,
		availability: {
			week: randomSlice(dayParts, random(0, 3)),
			weekend: randomSlice(dayParts, random(0, 3))
		}
	}
}